import { useDemo } from '@hooks/useDemo'
import './DemoBanner.scss'

export default function DemoBanner() {
  const isDemo = useDemo()
  if (!isDemo) return null

  return (
    <div className="demo-banner" role="status">
      <span className="demo-banner__label">Demo</span>
      <span className="demo-banner__text">
        Stripe test card: 4242 4242 4242 4242
      </span>
      <span className="demo-banner__sep">|</span>
      <span className="demo-banner__text">
        Admin: demo@misslemon.ro / demo123
      </span>
    </div>
  )
}
